
      if (import.meta.env.PROD) {
        const analytics = document.createElement('script')
        analytics.charset = 'UTF-8'
        analytics.id = 'LA_COLLECT'
        analytics.src = 'https://sdk.51.la/js-sdk-pro.min.js'
        analytics.addEventListener('load', () => {
          window.LA?.init({ id: 'LHi5ANCT8D1CdIGc', ck: 'LHi5ANCT8D1CdIGc' })
        })
        document.head.append(analytics)
      }
    